import React, { useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { ExpandMore } from '@mui/icons-material';
import faqByCountry from '../../constants/faq/faq';
import InformationStack from '../../components/stacks/InformationStack';
import useGetCountry from '../../helpers/useGetCountry';
import { HELP_CENTER_URL } from '../../constants/links';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  INFORMATION_STACK_NO_BORDER,
} from '../../constants/mui-components';
import {
  containerStack,
  titleTypography,
  faqsStack,
  accordionStyles,
  accordionSummary,
  questionTypography,
  accordionDetails,
  answerTypography,
  buttonTypography,
} from './styles/help-faq.styles';
import CountryEnum from '../../constants/country-enum';

function HelpFAQ() {
  const theme = useTheme();
  const country = useGetCountry();
  const faqsData = faqByCountry[country] || {};
  const [expanded, setExpanded] = useState([]);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      setExpanded((prev) => [...prev, panel]);
    } else {
      setExpanded((prev) => prev.filter((id) => id !== panel));
    }
  };

  const renderAnswer = (answer) => {
    if (typeof answer === 'string') return answer;
    return answer.map((item) => {
      const { type, paddingLeft, text } = item;
      const itemStyle = { paddingLeft: paddingLeft || '1rem', margin: '0.5rem 0' };
      switch (type) {
        case 'enumerated':
          return (
            <ol style={itemStyle}>
              {text.map((line) => (
                <li style={{ marginBottom: '0.5rem' }}>
                  {line}
                </li>
              ))}
            </ol>
          );
        case 'text':
          return text;
        case 'tabular':
          return (
            <ul style={itemStyle}>
              {text.map((line) => (
                <li style={{ marginBottom: '0.5rem' }}>
                  {line}
                </li>
              ))}
            </ul>
          );
        default:
          return text;
      }
    });
  };

  return (
    <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={containerStack}>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="1rem">
        <InformationStack
          className={INFORMATION_STACK_NO_BORDER}
          text={faqsData.stackText}
          backgroundColor={theme.palette.primary.A700}
          textColor="white"
          variant="info_stack"
          fontWeight={800}
          sx={{
            padding: '0.5rem 1rem',
            borderRadius: '6.25rem',
          }}
        />
        <Typography variant="xlarge_2" sx={titleTypography(theme)}>
          {faqsData.titleText}
        </Typography>
      </Stack>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={faqsStack}>
        {faqsData.frequentlyAskedQuestions.map((question) => {
          const isExpanded = expanded.includes(question.id);
          return (
            <Accordion
              key={question.id}
              elevation={0}
              onChange={handleAccordionChange(question.id)}
              sx={accordionStyles}
            >
              <AccordionSummary
                sx={accordionSummary(theme, isExpanded)}
                expandIcon={(
                  <ExpandMore
                    sx={{
                      color: isExpanded ? theme.palette.primary.A700 : theme.palette.neutral.A700,
                    }}
                  />
                )}
              >
                <Typography variant="large_1" sx={questionTypography(theme, isExpanded)}>
                  {question.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={accordionDetails(theme)}>
                <Typography variant="medium_1" sx={answerTypography}>
                  {renderAnswer(question.answer)}
                </Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Stack>
      {country === CountryEnum.CHILE && (
        <Button
          id="help-faq-button"
          variant="newPrimary"
          onClick={() => window.open(HELP_CENTER_URL, '_blank')}
        >
          <Typography variant="medium_2" sx={buttonTypography}>
            {faqsData.buttonText}
          </Typography>
        </Button>
      )}
    </Stack>
  );
}

HelpFAQ.propTypes = {
};

export default HelpFAQ;
